import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const checkAuth = createAsyncThunk('auth/checkAuth', async () => {
  try {
    const accessToken = localStorage.getItem('authToken');
    const refreshToken = localStorage.getItem('refreshToken');
    const userId = localStorage.getItem('userId');
    const profileComplete = localStorage.getItem('profileComplete') === 'true';

    return {
      isAuthenticated: !!accessToken,
      userId,
      token: accessToken || null,
      refreshToken: refreshToken || null,
      profileComplete,
      loading: false,
    };
  } catch {
    return {
      isAuthenticated: false,
      userId: null,
      token: null,
      refreshToken: null,
      profileComplete: false,
      loading: false,
    };
  }
});

const initialState = {
  isAuthenticated: false,
  userId: null,
  token: null,         // accessToken
  refreshToken: null,
  loading: true,
  profileComplete: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login(state, action) {
      const { token, refreshToken, userId, profileComplete = false } = action.payload;
      localStorage.setItem('authToken', token);
      localStorage.setItem('refreshToken', refreshToken);
      localStorage.setItem('profileComplete', profileComplete);
      localStorage.setItem('userId', userId);
      state.isAuthenticated = true;
      state.userId = userId;
      state.token = token;
      state.refreshToken = refreshToken;
      state.profileComplete = profileComplete;
      state.loading = false;
    },
    // Called by the refresh interceptor to silently update tokens
    tokenRefreshed(state, action) {
      const { token, refreshToken } = action.payload;
      localStorage.setItem('authToken', token);
      localStorage.setItem('refreshToken', refreshToken);
      state.token = token;
      state.refreshToken = refreshToken;
    },
    logout(state) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('profileComplete');
      localStorage.removeItem('userId');
      state.isAuthenticated = false;
      state.userId = null;
      state.token = null;
      state.refreshToken = null;
      state.profileComplete = false;
      state.loading = false;
    },
    updateProfileStatus(state, action) {
      localStorage.setItem('profileComplete', action.payload);
      state.profileComplete = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(checkAuth.fulfilled, (state, action) => {
        state.isAuthenticated = action.payload.isAuthenticated;
        state.userId = action.payload.userId;
        state.token = action.payload.token;
        state.refreshToken = action.payload.refreshToken;
        state.profileComplete = action.payload.profileComplete;
        state.loading = false;
      })
      .addCase(checkAuth.rejected, (state) => {
        state.loading = false;
        state.isAuthenticated = false;
      });
  },
});

export const { login, logout, tokenRefreshed, updateProfileStatus, setLoading } = authSlice.actions;
export default authSlice.reducer;